import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { Plant } from "../../models/navigation";
import { apsCommands } from "../../shared/dto/aps.commands";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NewGuidServiceName, { NewGuidService } from "../../services/utility/newguid.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import SectionChangeServiceName, { SectionChangeService } from "../../services/toolChange/sectionChange.service";
import JobRunServiceName, { JobRunService } from "../../services/jobs/jobRun.service";
import template from './editJobRun.tpl.html';
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";

let requires = [LoaderServiceName, NewGuidServiceName, NotifyServiceName, SectionChangeServiceName, JobRunServiceName, AuthDataServiceName];

export interface JobRunEditorData {
  jobRun?: apsViewModels.JobRunItem;
  shop: apsViewModels.ShopNavigation;
  plant: Plant;
  jobRuns: apsViewModels.JobRunItem[];
  jobs: apsViewModels.JobItem[];
}

export interface AddEditJobRun extends apsCommands.JobRunBase {
  endDate: Date;
  job: apsViewModels.JobItem;
  selectedRejectedEquipment:EquipmentRejectedPercentage[];
}
export interface EquipmentRejectedPercentage {
  selectedMachine:string;
  rejectedMinPercentage:number;
  rejectedMaxPercentage:number;
}
interface JobRunEditController {
  strategies: apsViewModels.SectionChangeStrategyDetail[];
  jobs: apsViewModels.JobItem[];
  editJob: AddEditJobRun;
  form: angular.IFormController;
  startDateString: any;
  endDateString: any;
  isNewJob: boolean;
  jobName: string;
  timeZone: string;
  casePacker: boolean;
  palletizer: boolean;
  showAlertFields: boolean;
  targetDoesNotExist: boolean;
  jobNameChanged(): void;
  save(): void;
  close(): void;
  minDate: moment.Moment;
  maxDate(): moment.Moment;
  endDateRequired(): boolean;
  minStartDate: string;
  maxEndDate: string;
  maxStartDate(): string;
  minEndDate(): string;
  showHelp(helpScreen: string): void;
  toggleHelpWindow(): void;
  showHelpWindow: boolean;
  helpText: string;
  isAdmin: boolean;
  currentPlantTarget: number;
  onManualEdit(): void;
  equipmentNames:string[];
  equipment: EquipmentRejectedPercentage;
  equipmentAdd():void;
  equipmentRemove(reject:EquipmentRejectedPercentage):void;
}

function setPackingCheckBoxes(vm: JobRunEditController, jobRun: apsViewModels.JobRunItem) {
  vm.casePacker = !!(jobRun.containersPerCase || jobRun.casesPerCycle);
  vm.palletizer = !!(jobRun.containersPerTier || jobRun.tiersPerPallet);
}

export default angular.module('aps.controller.editJobRun', requires)
  .controller('EditJobRunCtrl', editJobRunCtrl)
  .name;

export function openEditJobRun(
  data: JobRunEditorData,
  $modal: mm.foundation.modal): angular.IPromise<AddEditJobRun> {
  return $modal.open({
    template: template,
    controller: 'EditJobRunCtrl as vm',
    resolve: {
      data: function () {
        return data;
      }
    }
  }).result;
}

function editJobRunCtrl(
  $modalInstance: mm.foundation.modalInstance,
  loaderService: LoaderService,
  newGuidService: NewGuidService,
  notifyService: NotifyService,
  jobRunService: JobRunService,
  sectionChangeService: SectionChangeService,
  authDataService: AuthDataService,
  data: JobRunEditorData) {
  let vm = this as JobRunEditController;
  vm.showHelp = null;
  vm.showHelpWindow = false;
  vm.isAdmin = false;
  vm.helpText = null;
  vm.equipmentNames=[];
  vm.toggleHelpWindow = null;
  let plant: Plant = data.plant;
  let shop = data.shop;
  let jobRun = data.jobRun;
  vm.jobs = _.filter(data.jobs, { isDeleted: false });
  let previousJobRun: apsViewModels.JobRunItem;
  let nextJobRun: apsViewModels.JobRunItem;
  vm.isNewJob = false;
  let now = DateUtilityService.currentMinute();
  vm.timeZone = plant.timeZoneId;
  this.showAlertFields = true;
  this.targetDoesNotExist = false;

  if (jobRun) {
    vm.editJob = _.assign<AddEditJobRun>({}, jobRun);
    if(vm.editJob["machineRejectPercentage"]!= undefined){
      vm.editJob.selectedRejectedEquipment=JSON.parse(vm.editJob["machineRejectPercentage"]);
      } else{vm.editJob.selectedRejectedEquipment=[];}
    setPackingCheckBoxes(vm, jobRun);
    previousJobRun = _.first(_.filter(_.orderBy(data.jobRuns, ['startDate'], ['desc']),
      j => j.startDate.getTime() < jobRun.startDate.getTime()));

    nextJobRun = _.first(_.filter(_.sortBy(data.jobRuns, 'startDate'),
      j => j.startDate.getTime() > jobRun.startDate.getTime()));   
  } 
  
  else {
    vm.isNewJob = true;
    vm.editJob = {} as AddEditJobRun;
    vm.editJob.shopId = shop.id;
    vm.editJob.startDate = DateUtilityService.getHourForTimeZone(now.toDate(), 7, plant.timeZoneId);
    newGuidService.getNewGuid('jobRun').then(function (id) {
      vm.editJob.id = id;
    });
   
    vm.editJob.numberOfSections = data.shop.defaultNumberOfSections;
    vm.editJob.numberOfGobs = data.shop.defaultNumberOfGobs;

    previousJobRun = _.first(_.orderBy(data.jobRuns, ['startDate'], ['desc']));
    if (previousJobRun && previousJobRun.containerSpeed > 0) {
      vm.editJob.containerSpeed = previousJobRun.containerSpeed;
    }
    
    if(vm.editJob["machineRejectPercentage"]!= undefined){
      vm.editJob.selectedRejectedEquipment=JSON.parse(vm.editJob["machineRejectPercentage"]);
      } else{vm.editJob.selectedRejectedEquipment=[];}
  }
  jobRunService.getEquipmentByShopName(shop.id).then((result) => {
    
    _.forEach(result, (equipmentEntity: any) => {
      if(vm.editJob.selectedRejectedEquipment==undefined || vm.editJob.selectedRejectedEquipment.filter(m=>m.selectedMachine ==equipmentEntity).length==0)
      {
      vm.equipmentNames.push(equipmentEntity);
      }
    });
});
  vm.isAdmin = authDataService.isAPSIOAdmin();
  let isStrategyIdValid = (strategyId: string) => {
    if (strategyId) {
      return _.some(vm.strategies, s => s.id === strategyId);
    }
    return false;
  };
  
  let clearStrategyIdIfInvalid = () => {
    if (!isStrategyIdValid(vm.editJob.sectionChangeStrategyId)) {
      vm.editJob.sectionChangeStrategyId = null;
    }
  };

  loaderService.loadingPromise(sectionChangeService.getStrategiesForShop(shop).then(data => {
    vm.strategies = data;
    clearStrategyIdIfInvalid();
    if (vm.isNewJob) {
      let strategy = _.find(vm.strategies, (s: apsViewModels.SectionChangeStrategyDetail) =>
        s.isDefault && s.shopId === shop.id);
      if (!strategy) {
        strategy = _.find(vm.strategies, (s: apsViewModels.SectionChangeStrategyDetail) =>
          s.isDefault && s.shopId === null && s.plantId === shop.plantId);
        if (!strategy) {
          strategy = _.find(vm.strategies, (s: apsViewModels.SectionChangeStrategyDetail) =>
            s.isDefault && s.shopId === null && s.plantId === null);
        }
      }
      if (strategy) {
        vm.editJob.sectionChangeStrategyId = strategy.id;
      }
    }
  }));

  vm.jobName = vm.editJob.job ? vm.editJob.job.name : '';

  vm.minDate = moment([2000]);
  if (previousJobRun) {
    vm.minDate = moment(previousJobRun.startDate).add(1, 'minutes');
  }

  vm.maxDate = function () {
    if (nextJobRun) {
      return moment(nextJobRun.startDate);
    }
    return moment().add(1, 'years');
  };  

  vm.minStartDate = DateUtilityService.formatISO(vm.minDate, plant.timeZoneId);
  vm.maxEndDate = DateUtilityService.formatISO(vm.maxDate(), plant.timeZoneId);
  vm.maxStartDate = () => {
    if (vm.editJob.endDate) {
      return DateUtilityService.formatISO(vm.editJob.endDate, plant.timeZoneId);
    }
    return vm.maxEndDate;
  };
  vm.minEndDate = () => {
    if (vm.editJob.startDate) {
      let minEndDate = moment(vm.editJob.startDate).add(1, 'minutes').toDate();
      return DateUtilityService.formatISO(minEndDate, plant.timeZoneId);
    }
    return vm.minStartDate;
  };

  vm.endDateRequired = function () {
    return !!nextJobRun;
  };

  vm.jobNameChanged = () => {
    vm.editJob.job = _.find(vm.jobs, { name: vm.jobName });
    if (!vm.editJob.job) {
      return;
    }
    jobRunService.getTarget(plant.id, vm.editJob.job.mold, vm.editJob.job.finish, vm.editJob.job.glassColorName).then((result) => {
      if (result === null) {
        vm.targetDoesNotExist = true;
      } else {
        vm.targetDoesNotExist = false;
        vm.currentPlantTarget = result;
        vm.editJob.packPercentageTarget = result;
      }
    });
    let previousJobRun = _.find(data.jobRuns, { jobId: vm.editJob.job.id });
    if (!previousJobRun) {
      return;
    }

    vm.editJob.lehrTime = previousJobRun.lehrTime;
    vm.editJob.numberOfSections = previousJobRun.numberOfSections;
    vm.editJob.numberOfGobs = previousJobRun.numberOfGobs;
    if (previousJobRun.containerSpeed > 0) {
      vm.editJob.containerSpeed = previousJobRun.containerSpeed;
    }
    if (previousJobRun.containersPerCase > 0) {
      vm.editJob.containersPerCase = previousJobRun.containersPerCase;
      vm.editJob.casesPerCycle = previousJobRun.casesPerCycle;
    }
    if (previousJobRun.containersPerTier > 0) {
      vm.editJob.containersPerTier = previousJobRun.containersPerTier;
      vm.editJob.tiersPerPallet = previousJobRun.tiersPerPallet;
    }
    vm.editJob.weightTarget = previousJobRun.weightTarget;
    vm.editJob.weightAlarmUpper = previousJobRun.weightAlarmUpper;
    vm.editJob.weightAlarmLower = previousJobRun.weightAlarmLower;
    vm.editJob.weightWarningUpper = previousJobRun.weightWarningUpper;
    vm.editJob.weightWarningLower = previousJobRun.weightWarningLower;
    vm.editJob.automaticSectionChanges = previousJobRun.automaticSectionChanges;
    if (isStrategyIdValid(previousJobRun.sectionChangeStrategyId)) {
      vm.editJob.sectionChangeStrategyId = previousJobRun.sectionChangeStrategyId;
    }
    setPackingCheckBoxes(vm, previousJobRun);
  };

  vm.save = () => {
    if (vm.form.$invalid) {
      return;
    }
    vm.editJob.jobId = vm.editJob.job.id;
    let startDate = moment(vm.editJob.startDate);
     if (startDate < vm.minDate) {
       notifyService.error('Start Date may not be before ' +
         DateUtilityService.formatTime(vm.minDate, plant.timeZoneId));
       return;
     }

    if (vm.editJob.endDate) {
      let endDate = moment(vm.editJob.endDate);
      let maxDate = vm.maxDate();
      if (endDate > maxDate) {
        notifyService.error('End Date may not be after ' +
          DateUtilityService.formatTime(maxDate, plant.timeZoneId));
        return;
      }

       if(endDate < maxDate){
         notifyService.error('End Date must be same as next job Start Date ' +
         DateUtilityService.formatTime(maxDate, plant.timeZoneId))
         return;
       }

      let minEndDate = startDate.add(1, 'minutes');
      if (endDate < minEndDate) {
        notifyService.error('End Date may not be on or before Start Date');
        return;
      }
    }
    vm.editJob.MachineRejectPercentage= JSON.stringify(vm.editJob.selectedRejectedEquipment, function( key, value ) {
      if( key === "$$hashKey" ) {
          return undefined;
      }
  
      return value;
  });
    
    if (!vm.editJob.automaticSectionChanges) {
      vm.editJob.sectionChangeStrategyId = null;
    }

    if (!vm.casePacker) {
      vm.editJob.containersPerCase = null;
      vm.editJob.casesPerCycle = null;
    }
    if (!vm.palletizer) {
      vm.editJob.containersPerTier = null;
      vm.editJob.tiersPerPallet = null;
    }
    if(!vm.editJob.activeSections){
      vm.editJob.activeSections = vm.editJob.numberOfSections;
    }
    const isTargetChangedForNew =
      vm.editJob.packPercentageTarget !== null &&
      vm.currentPlantTarget !== vm.editJob.packPercentageTarget;

    const isTargetChangedForExisting =
      vm.editJob.packPercentageTarget !== null &&
      !jobRun.isOverridenByAdmin &&
      (vm.currentPlantTarget !== vm.editJob.packPercentageTarget ||
        jobRun.packPercentageTarget !== vm.editJob.packPercentageTarget);

    vm.editJob.isOverridenByAdmin =
      vm.isAdmin &&
      (vm.isNewJob ? isTargetChangedForNew : isTargetChangedForExisting);

    let submit;
    if (vm.isNewJob) {
      submit = jobRunService.addJobRun(vm.editJob);
    } else {
      submit = jobRunService.updateJobRun(vm.editJob).then(()=>{
        if(previousJobRun && previousJobRun.endDate.getTime() !== vm.editJob.startDate.getTime()){
          previousJobRun.endDate = vm.editJob.startDate;
          submit = jobRunService.updateJobRun(previousJobRun);
        }});   
    }
    vm.editJob["machineRejectPercentage"]=vm.editJob.MachineRejectPercentage;
    loaderService.loadingPromise(
      submit.then(function () {
        if (previousJobRun && previousJobRun.endDate) {
          previousJobRun.endDate = vm.editJob.startDate;
        }
        $modalInstance.close(vm.editJob);
      }, notifyService.handleApiErrors));
  };

  vm.close = () => {
    $modalInstance.close();
  };
  vm.toggleHelpWindow = (): void => {
    vm.showHelpWindow = !vm.showHelpWindow;
  }

  vm.showHelp = (): void => {
    vm.helpText = getHelpText();
    vm.toggleHelpWindow();
  }

  vm.equipmentAdd = (): void=> {
    
    if(this.equipment == undefined || this.equipment.selectedMachine== undefined )
      {
        notifyService.error('Please select a Machine' );

    return;}
    
    if (this.equipment !== null && this.equipment !== undefined && this.equipment.selectedMachine !== undefined) {
      
      
      if(this.equipment.rejectedMinPercentage== undefined || this.equipment.rejectedMinPercentage == null || this.equipment.rejectedMinPercentage < 0 )
      {
        notifyService.error('Please enter a valid Min Percentage ' );

    return;}
    if(this.equipment.rejectedMaxPercentage== undefined || this.equipment.rejectedMaxPercentage == null )
    {
      notifyService.error('Please enter a valid Max percentage' );

  return;}
      vm.editJob.selectedRejectedEquipment.push(vm.equipment);
       this.equipmentNames = this.equipmentNames.filter(obj =>  obj !== vm.equipment.selectedMachine);
         vm.equipment=null;
     }
  };

  vm.equipmentRemove = (equipment: EquipmentRejectedPercentage):void => {
    _.remove(vm.editJob.selectedRejectedEquipment, equipment);
    vm.equipmentNames.push(equipment.selectedMachine);
  };




  function getHelpText(): string {
    return `  
    <div class="header">
      Job Change Difficulties
    </div>         
    <div class="detail">
      (0-7) are the different types of Difficulties
    </div>  
    <div class="detail">
      <ol type = "1" start ="0">
        <li class="detail">
          <b>Exceptions</b> <br>
          <ol type = "a">
            <li class="detail">Unforseen Mechanical failure causing more than 4 hours of downtime</li>
            <li class="detail">PM causing more than 4 hours of downtime</li>
            <li class="detail">Job Change occurs within a color change (glass is not salable)</li>
            <li class="detail">Problems with production due to circumstances outside plant control (e.g. poor blank/mold design)</li>
            <li class="detail">Problems with the glass quality preventing pack</li>
            <li class="detail">Production period is less than 12 hours</li>
            <li class="detail">Sampling</li>
            <li class="detail">Other (describe in comments)</li>
          </ol>
        </li>
        <li class="detail">
          <b>Finish/Bottom Plate Change</b> <br>Only the Neck Ring or Bottom Plate is changed.
        </li>
        <li class="detail">
          <b>Mold Change</b> <br>Only the molds are changed.
        </li>
        <li class="detail">
          <b>Small Job Change</b> <br>Any combination of the following:
            <ol type = "a">
              <li class="detail">Mold Change</li>
              <li class="detail">Blank Change</li>
              <li class="detail">Neck Rings / Neck Ring Arm Adjustment</li>
              <li class="detail">Adjustment to invert level</li>
            </ol>
        </li>
        <li class="detail">
          <b>Medium Job Change</b> <br>1 Set of hangers is changed out or delivery equipment is changed.
        </li>
        <li class="detail">
          <b>Large Job Change</b> <br>Both sets of hangers are changed out.
        </li>
        <li class="detail">
          <b>Process Change</b> <br>Any job change where the production process is changed between NNPB, PB and B&B.
        </li>
        <li class="detail">
          <b>Mechanical Conversion</b> <br>A machine change between single, double, or triple gob production.
        </li>
      </ol>
    </div>
      `;
  }
}


// WEBPACK FOOTER //
// ./src/app/controllers/jobRun/editJobRun.controller.ts